var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from "lodash";
import { DiagramBase } from '../basics/DiagramBase';
import { prepareDiagramData2D } from '../basics/Statistics';
import { setOrDef, setIfDef } from "../Helpers";
var Pie = /** @class */ (function (_super) {
    __extends(Pie, _super);
    function Pie() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            data: undefined
        };
        _this.calcData = function (props) {
            var d = props.diagram;
            prepareDiagramData2D(props.diagram, {
                type: "pie",
                roseType: d.roseType ? d.roseType : false,
                radius: [
                    setOrDef(d, function (x) { return x.innerRadius; }, 0) + "%",
                    setOrDef(d, function (x) { return x.outerRadius; }, 75) + "%"
                ],
                label: {
                    position: setOrDef(d.label, function (x) { return x.position; }, 'outside'),
                    show: setOrDef(d.label, function (x) { return x.show; }, true),
                    formatter: setIfDef(d.label, function (x) { return _this.getLabelFormatter(x); }),
                    color: setIfDef(d.label, function (x) { return x.color; }),
                    fontSize: setOrDef(d.label, function (x) { return x.fontSize; }, 16),
                    rich: setIfDef(d.label, function (x) { return x.rich; })
                },
                emphasis: d.emphasis ? {
                    label: {
                        position: setOrDef(d.emphasis, function (x) { return x.position; }, 'outside'),
                        show: true,
                        formatter: _this.getLabelFormatter(d.emphasis),
                        color: d.emphasis.color,
                        fontSize: setOrDef(d.emphasis, function (x) { return x.fontSize; }, 16),
                    }
                } : {
                    show: true,
                    fontSize: setOrDef(d.label, function (x) { return x.fontSize; }, 16),
                    fontWeight: 'bold'
                },
                hoverOffset: d.hoverAnimation !== undefined ? (d.hoverAnimation ? 10 : 0) : undefined,
                hoverAnimation: d.hoverAnimation !== undefined ? d.hoverAnimation : true,
                labelLine: {
                    length: 20,
                    length2: 40,
                    smooth: false,
                }
            }).then(function (data) {
                //      console.log(data);
                _this.setState({ data: data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.getOption = function () {
            if (!_this.state.data)
                return undefined;
            var d = _this.props.diagram;
            var option = {
                backgroundColor: d.backgroundColor,
                color: d.colors ? d.colors.colors : undefined,
                tooltip: {
                    show: setOrDef(d.tooltip, function (x) { return x.show; }, true),
                    trigger: 'item',
                    formatter: d.tooltip && d.tooltip.formatter ? d.tooltip.formatter : _this.formatter,
                    fontSize: setOrDef(d.tooltip, function (x) { return x.fontSize; }, 16),
                    color: setIfDef(d.tooltip, function (x) { return x.color; }),
                    fontWeight: 'bold'
                },
                toolbox: {
                    bottom: 0,
                    left: 2,
                    showTitle: false,
                    orient: 'vertical',
                    feature: {
                        saveAsImage: {
                            show: setOrDef(d.legend, function (x) { return x.showDownload; }, false),
                        }
                    }
                },
                legend: d.legend && d.legend.show ? {
                    show: true,
                    orient: setOrDef(d.legend, function (x) { return x.direction; }, 'vertical'),
                    align: setOrDef(d.legend, function (x) { return x.itemAlign; }, 'auto'),
                    left: setOrDef(d.legend, function (x) { return x.horizontalAlignment; }, 'right'),
                    top: setOrDef(d.legend, function (x) { return x.verticalAlignment; }, 'top'),
                    padding: [
                        setOrDef(d.legend.padding, function (x) { return x.top; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.right; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.bottom; }, 0),
                        setOrDef(d.legend.padding, function (x) { return x.left; }, 0),
                    ],
                    color: setOrDef(d.legend, function (x) { return x.fontColor; }, '#000000'),
                } : { show: false },
                series: _this.state.data && _this.state.data.data && _this.state.data.data.series && _this.state.data.data.series.length > 0 ? [_this.state.data.data.series[0]] : undefined,
            };
            //console.log(option);
            return option;
        };
        _this.findDataElement = function (path) {
            if (Object.keys(path).length > 1)
                return undefined;
            var keys = _this.state.data.keys;
            var i = _.findIndex(keys[0].names, function (v) { return v === path[keys[0].key]; });
            if (i >= 0) {
                var series = _this.state.data.data.series;
                return [series[0].data[i]];
            }
            return undefined;
        };
        _this.getClickPath = function (data) {
            var toRet = {};
            toRet[_this.props.diagram.groupBy[0]] = data.name;
            return toRet;
        };
        _this.onClick = function (data) {
            _this.redraw();
            _super.prototype.onClick.call(_this, data);
        };
        _this.formatter = function (data) {
            return "<div style='display: inline-block; border-radius: 50%; background-color: " + data.color + "; width: 10px; height: 10px;'></div> <span>" + data.name + ":" + data.value + "</span>";
        };
        return _this;
    }
    Pie.prototype.needRecalc = function (props) {
        var res = _super.prototype.needRecalc.call(this, props);
        var d = props.diagram;
        var n = this.props.diagram;
        res = res || d.innerRadius !== n.innerRadius;
        res = res || d.outerRadius !== n.outerRadius;
        res = res || !_.isEqual(d.label, n.label);
        res = res || d.roseType !== n.roseType;
        return res;
    };
    return Pie;
}(DiagramBase));
export default Pie;
//# sourceMappingURL=Pie.js.map